import "../../stylesheets/App.css";
import "../../stylesheets/UserItem.css";
import React from "react";

function UserItem(props) {
  const background1 = {
    background: "var(--color-turquesa-claro)",
    color: "white",
    boxSizing: "content-box",
  };
  const background2 = {
    background: "#FFC728",
    color: "white",
    boxSizing: "content-box",
  };
  const background3 = {
    background: "#8B1D41",
    color: "white",
    boxSizing: "content-box",
  };
  const background4 = {
    background: "var(--color-inputs)",
    boxSizing: "content-box",
    color: "var(--color-turquesa-oscuro)",
  };

  const userInfoRaw = localStorage.getItem("user-info");
  const userInfo = userInfoRaw ? JSON.parse(userInfoRaw) : null;

  const isCurrentUser =
    userInfo && props.user && props.user.idUser === userInfo.idUser;

  const rankStyle =
    props.index === 1
      ? background1
      : props.index === 2
      ? background2
      : props.index === 3
      ? background3
      : background4;

  return (
    <div
      className="ranking-user-container"
      onClick={props.onClick ? props.onClick : undefined}
      id={isCurrentUser ? "user-actual" : "user" + props.index}
    >
      <div className="ranking-number" style={rankStyle}>
        {props.index}
      </div>

      <div className="ranking-user-name">{props.user?.name || ""}</div>
      <div className="ranking-user-score">
        {(props.user?.score ?? 0) + " Puntos"}
      </div>
    </div>
  );
}

export default UserItem;
